




























































import { namespace } from 'vuex-class';
import { Component, Vue } from 'vue-property-decorator';
import CodeEditor from '@components/common/code-editor/CodeEditor.vue';
import { ZkTreeNode, ZookeeperResponse } from '@service/solr/admin/zookeeper';
import { ElUpload } from 'element-ui/types/upload';
import { TreeNode } from 'element-ui/types/tree';
import { AxiosResponse } from 'axios';

const Store = namespace('management/configSets');

@Component({
  components: {
    CodeEditor,
  },
})
export default class ConfigSets extends Vue {
  private treeProps = {
    label: (data: ZkTreeNode) => {
      const title = data.data?.title || data?.text || '-';
      return title === '/' ? title : title.replace(/^\//, '');
    },
  };

  private loadingFileContent = false;
  private createConfigSetDialogVisible = false;
  private language = 'text';
  private newConfigSet = {
    name: '',
    baseConfigSet: '',
  };

  private creatingConfigSet = false;
  private method = 'base';

  @Store.State private configSets!: ZkTreeNode[];
  @Store.State private loadingConfigSets!: boolean;
  @Store.State private fileContent!: string;

  @Store.Mutation private setFileContent!: (content: string) => void;
  @Store.Action private loadConfigSets!: () => void;

  private nodeClicked(data: ZkTreeNode, node: TreeNode<string, ZkTreeNode>) {
    if (node.isLeaf) {
      this.loadingFileContent = true;
      const url = data.data?.attr.href || data.a_attr?.href || '-';
      this.$http.get(`/solr/${url}`).then(
        (res: AxiosResponse<ZookeeperResponse>) => {
          this.loadingFileContent = false;
          this.setFileContent(res.data.znode.data || '');
          if (url.match(/.*\.json$/)) {
            this.language = 'json';
          } else if (url.match(/.*\.xml$/) || url.match(/managed-schema$/)) {
            this.language = 'xml';
          } else if (url.match(/.*\.js$/)) {
            this.language = 'javascript';
          } else {
            this.language = 'text';
          }
        },
        () => (this.loadingFileContent = false),
      );
    }
  }

  private deleteConfigSet(data: ZkTreeNode) {
    const name = data.data?.title || data?.text || '-';
    this.$confirm(`Do you want to delete config set: "${name}"`, 'Delete Config Set').then(
      () => {
        const loading = this.$loading({
          lock: true,
          text: 'Deleting',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        });
        this.$http
          .get('/solr/admin/configs', {
            params: {
              action: 'DELETE',
              name: name,
            },
          })
          .then(
            () => {
              loading.close();
              this.loadConfigSets();
            },
            () => {
              loading.close();
            },
          );
      },
      () => ({}),
    );
  }

  private upload(param: { file: string }) {
    const formData = new FormData();
    formData.append('name', this.newConfigSet.name);
    formData.append('file', param.file);
    this.$http.post('/solr/admin/configs?action=CREATE', formData).then(
      () => ({}),
      () => ({}),
    );
  }

  private createConfigSet() {
    if (this.method === 'upload') {
      (this.$refs.uploader as ElUpload).submit();
      return;
    }
    if (this.creatingConfigSet) return;
    this.creatingConfigSet = true;
    this.$http
      .get('/solr/admin/configs', {
        params: {
          action: 'CREATE',
          name: this.newConfigSet.name,
          baseConfigSet: this.newConfigSet.baseConfigSet,
        },
      })
      .then(() => {
        this.createConfigSetDialogVisible = false;
        this.loadConfigSets();
      })
      .catch((err) => {
        this.$notify.error(`${err?.response?.statusText}: ${err?.response?.data?.exception?.msg}`);
      })
      .finally(() => {
        this.creatingConfigSet = false;
      });
  }

  created() {
    this.loadConfigSets();
  }
}
